import React,{Component} from 'react';			

export default class ThemeButton extends Component{
	render(){
		return(
			<>
				{/* <a href="https://themeforest.net/item/umang-academy-kindergarden-kids-play-school-react-template/30820866" rel="noopener noreferrer" target="_blank" className="bt-buy-now theme-btn"><i className="ti-shopping-cart"></i><span>Buy Now</span></a>
				<a href="https://w3itexperts.ticksy.com" rel="noopener noreferrer" target="_blank" className="bt-support-now theme-btn"><i className="ti-headphone-alt"></i><span>Support</span></a> */}
			</>
		)
	}	
}